import ko from 'knockout';
import _ from 'underscore';
import { keyCode } from '@bingads-webui/keycode';

export class AddCardViewModel {
  constructor({
    allAvailableCards,
    selectedCards,
    i18n,
    updateFocusedIndex,
  }) {
    this.selectedCards = selectedCards;
    this.i18n = i18n;
    const getFirstFocusableIndex = (cards) => {
      const firstSelectedIndex = _.findIndex(
        cards,
        card => card.selected()
      );
      return firstSelectedIndex === -1 ? 0 : firstSelectedIndex;
    };

    // construct the observables
    _.each(allAvailableCards, (card) => {
      _.extend(card, {
        selected: ko.observable(_.findIndex(
          selectedCards,
          selected => selected === card.typeId
        ) !== -1),
      });

      _.extend(card, {
        appliedClass: ko.pureComputed(() => {
          if (card.selected()) {
            return `add-card__thumbnail-${card.cssKey} add-card__thumbnail-${card.cssKey}--selected`;
          }
          return `add-card__thumbnail-${card.cssKey}`;
        }, card),
      });
    });

    this.firstFocusedIndex = ko.observable(getFirstFocusableIndex(allAvailableCards));

    this.allCards = ko.observableArray(allAvailableCards);

    this.cardsToAdd = ko.pureComputed(() => _.chain(this.allCards())
      .filter(card => card.selected() === true)
      .pluck('typeId')
      .difference(this.selectedCards)
      .value());

    this.cardsToDelete = ko.pureComputed(() => _.chain(this.allCards())
      .filter(card => card.selected() !== true)
      .pluck('typeId')
      .intersection(this.selectedCards)
      .value());

    this.selectedTilesNumber = ko.pureComputed(() => {
      const selectedGroup = _.countBy(this.allCards(), c => (c.selected() === true ? 'selected' : 'unselected'));

      return selectedGroup.selected || 0;
    }, this);

    // Simple click callback, only for toggle state
    this.onThumbnailClicked = (card) => {
      card.selected(!card.selected());
      this.firstFocusedIndex(getFirstFocusableIndex(allAvailableCards));
    };

    this.onKeyPress = (card, event) => {
      if (event.keyCode === keyCode.Space) {
        card.selected(!card.selected());
        this.firstFocusedIndex(getFirstFocusableIndex(allAvailableCards));
        event.preventDefault();
      }
    };

    this.onFocus = (card) => {
      const index = allAvailableCards.indexOf(card);
      updateFocusedIndex(index);
    };
  }
}
